/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Add_Apple_Sso_EmailInputs */



/**
* | output |
* | --- |
* | "Apple sign-in address (optional)" |
*
* @param {Members_Add_Apple_Sso_EmailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_add_apple_sso_email = /** @type {((inputs?: Members_Add_Apple_Sso_EmailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Add_Apple_Sso_EmailInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Apple-Anmeldeadresse (optional)")
	return /** @type {LocalizedString} */ ("Apple sign-in address (optional)")
});